import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, ClockIcon, PhoneIcon, InstagramIcon } from 'lucide-react';
interface FooterProps {
  isDark: boolean;
  minimal?: boolean;
}
export function Footer({
  isDark,
  minimal = false
}: FooterProps) {
  return <footer className="border-t border-slate-200 dark:border-white/5 pt-16 pb-8 bg-white dark:bg-[#0f1629] transition-colors duration-300 relative z-10" data-id="element-63" data-mp="32lrnnhvi55m3">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64" data-mp="3ug3gromz2pcd">
        <div className={`${minimal ? 'flex justify-center' : 'grid grid-cols-1 md:grid-cols-3 gap-12'} mb-12`} data-id="element-65" data-mp="38h4j7m6tejw">
          <div className={minimal ? 'text-center' : 'md:col-span-1'} data-id="element-66" data-mp="3ldan5eqbi1jd">
            <Link to="/" className={`flex items-center mb-4 group ${minimal ? 'justify-center' : ''}`} data-id="element-67" data-mp="3qd6spieny111">
              <img src="https://cdn.magicpatterns.com/uploads/miVDHRURGJeqgpYC7Z9kCF/logo.png" alt="Scale Finance Strategies" className="h-8 w-auto object-contain dark:brightness-0 dark:invert" style={{
              width: "142px",
              height: "70px"
            }} data-id="element-68" data-mp="29xlzel58oyhi" />
            </Link>
            <p className={`text-slate-500 dark:text-slate-400 text-xs leading-relaxed ${minimal ? 'max-w-md mx-auto' : ''}`} data-id="element-69" data-mp="3gaz3z8yymvmq">
              Built for Australians that want more than just one property — we
              help you scale your portfolio through smarter strategy, education
              and the right team.
            </p>

            <div className={`mt-5 space-y-3 ${minimal ? 'inline-flex flex-col items-center' : ''}`} data-id="element-70" data-mp="80xi63gl8rgz">
              <div className="flex items-center gap-2.5" data-id="element-71" data-mp="hsk1yo6zryvc">
                <MailIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-72" data-mp="hs1wr22cqaba" />
                <a href="mailto:liam@scalefinancestrategies.com.au" className="text-xs text-slate-500 dark:text-slate-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-73" data-mp="cv1qaq1lb5jn">
                  liam@scalefinancestrategies.com.au
                </a>
              </div>
              <div className="flex items-center gap-2.5" data-id="element-74" data-mp="tt9y8bqxspv4">
                <PhoneIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-75" data-mp="yuzce09ghjnf" />
                <a href="tel:+610403191672" className="text-xs text-slate-500 dark:text-slate-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-76" data-mp="13t0tifnbn8w9">
                  +61 0403 191 672
                </a>
              </div>
              <div className="flex items-center gap-2.5" data-id="element-77" data-mp="1hjw888ki4k7r">
                <InstagramIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-78" data-mp="1hmif05zkivox" />
                <a href="https://www.instagram.com/scalefinancestrategies?utm_source=qr" target="_blank" rel="noopener noreferrer" className="text-xs text-slate-500 dark:text-slate-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-79" data-mp="1mkjukgxsccvn">
                  @scalefinancestrategies
                </a>
              </div>
              <div className="flex items-center gap-2.5" data-id="element-80" data-mp="25of0i8nis2jf">
                <ClockIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-81" data-mp="25mu74mcxypn5" />
                <span className="text-xs text-slate-500 dark:text-slate-400" data-id="element-82" data-mp="21nv2z3z1awwr">
                  Mon – Fri: 8:30 AM – 5:30 PM AWST
                </span>
              </div>
            </div>
          </div>

          {!minimal && <>
              <div data-id="element-83" data-mp="2tbn48m5av3jc">
                <h4 className="text-slate-900 dark:text-white font-semibold mb-4 text-sm" data-id="element-84" data-mp="2pcnu8n4pogl1">
                  Quick Links
                </h4>
                <ul className="space-y-2.5 text-sm text-slate-500 dark:text-slate-400" data-id="element-85" data-mp="2kc06cabs4fv1">
                  <li data-id="element-86" data-mp="2fd5defk3lax7">
                    <Link to="/#services" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-87" data-mp="2fdym3m2maahz">
                      Services
                    </Link>
                  </li>
                  <li data-id="element-88" data-mp="2ruogv85vonzy">
                    <Link to="/#about" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-89" data-mp="2ru6ahipi4teb">
                      About
                    </Link>
                  </li>
                  <li data-id="element-90" data-mp="2ntcqh0f6jyqp">
                    <Link to="/calculator" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-91" data-mp="2nuxh4eydixja">
                      Borrowing Power Calculator
                    </Link>
                  </li>
                  <li data-id="element-92" data-mp="31khjvkryfusl">
                    <Link to="/roadmap" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-93" data-mp="31laskrah4udd">
                      Savings Roadmap
                    </Link>
                  </li>
                  <li data-id="element-94" data-mp="1v6i4fz2psrb4">
                    <Link to="/#contact" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-95" data-mp="1v6rxxwmyxglk">
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>

              <div data-id="element-96" data-mp="1wkjl4xboqmb1">
                <h4 className="text-slate-900 dark:text-white font-semibold mb-4 text-sm" data-id="element-97" data-mp="1rnjdwj33ndic">
                  Legal
                </h4>
                <ul className="space-y-2.5 text-sm text-slate-500 dark:text-slate-400" data-id="element-98" data-mp="13x6v2d6bfwcz">
                  <li data-id="element-99" data-mp="zwwq93u9fbzp">
                    <Link to="/legal#privacy" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-100" data-mp="zxobplu57tc9">
                      Privacy Policy
                    </Link>
                  </li>
                  <li data-id="element-101" data-mp="l6p68joltkww">
                    <Link to="/legal#complaints" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-102" data-mp="l65yfvso4cwl">
                      Complaints Policy
                    </Link>
                  </li>
                  <li data-id="element-103" data-mp="2l8os6pa21qcs">
                    <Link to="/legal#terms" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-104" data-mp="2l7vsu9dfe34o">
                      Website Terms
                    </Link>
                  </li>
                </ul>
              </div>
            </>}
        </div>

        <div className="pt-8 border-t border-slate-200 dark:border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-105" data-mp="22achv07eqafm">
          <p className="text-xs text-slate-400 dark:text-slate-500 text-center md:text-left" data-id="element-106" data-mp="278e1bm8qwbrm">
            © 2026 Scale Finance Strategies Pty Ltd. All rights reserved. ACN
            654344260
          </p>
          <p className="text-xs text-slate-400 dark:text-slate-500 max-w-xl text-center md:text-right leading-relaxed" data-id="element-107" data-mp="3iouk9pjidaj8">
            General Advice Warning: All information on this website is general
            in nature and does not consider your personal circumstances. Any
            tools, calculators, or examples provided are for illustrative
            purposes only and may not be accurate or reflect your situation. You
            should seek personalised advice before making any financial
            decisions.
          </p>
        </div>
      </div>
    </footer>;
}